import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuBrand, BambuBrandUIConfig } from '../interfaces/brands';

/**
 * This class is used to construct the input to update a brand.  The inputs can either be provided as
 * part of the constructor, or set after the fact in the public properties.
 *
 * BrandId is required to update the brand.
 */
export class UpdateBrand extends Executable<BambuBrand> implements Partial<BambuBrand> {
  public brandId?: number;

  public name?: string;

  public description?: string;

  public tenantId?: number;

  public logo?: string;

  public reportSite?: string;

  public uiConfig?: BambuBrandUIConfig;

  public getMethod(): Method {
    return 'patch';
  }

  public getResponse(apiResponse: any): BambuBrand {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    return `/${this.brandId}`;
  }

  constructor(input?: Partial<BambuBrand> & { brandId: number }) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<BambuBrand> {
    if (!this.brandId) throw new Error('brandId is required');
    return {
      tenantId: this.tenantId,
      name: this.name,
      description: this.description,
      logo: this.logo,
      reportSite: this.reportSite,
      uiConfig: this.uiConfig,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
